module.exports = __webpack_public_path__ + "img/lastmile-hero.3c6e31fc.jpg";